<google-map
  #map
  [width]="'100%'"
  [center]="center"
  [zoom]="zoom">
  <map-marker
    *ngFor="let marker of markers"
    #mapMarker="mapMarker"
    [position]="marker.position"
    [options]="marker.options">
    <map-info-window>
      <div [innerHTML]="marker.infoWindowContent || getDefaultInfoWindowContent(marker)"></div>
    </map-info-window>
  </map-marker>
</google-map>